import { z } from "zod";

export const prestationPricingSchema = z.object({
  price: z.coerce.number(),
});

export const quantifySchemaExtend = {
  quantity: z.coerce.number(),
};

export const datedSchemaExtend = {
  dates: z.array(z.date()),
};
